// services/challengeLoaderService.js
// Asks the backend which animated loader to show while a challenge is being
// prepared. Called in parallel with POST /quiz/start and never allowed to get
// in its way: any failure (offline, slow, 5xx) resolves to null and the page
// keeps its standard spinner.
import { apiRequest } from './api';

export const CHALLENGE_LOADER_TIMEOUT_MS = 5000;

/**
 * @returns {Promise<{ loader: { id, name, videoUrl, posterUrl, version, categories } | null, mediaCategories: string[] }>}
 */
export async function selectChallengeLoader(tmdbId, kind) {
    try {
        const data = await apiRequest('/challenge-loaders/select', {
            params: { tmdbId, kind },
            quiet: true,
            retry: { retries: 0, timeoutMs: CHALLENGE_LOADER_TIMEOUT_MS },
        });
        const result = data?.data ?? data;
        return { loader: result?.loader?.videoUrl ? result.loader : null, mediaCategories: result?.mediaCategories || [] };
    } catch {
        return { loader: null, mediaCategories: [] };
    }
}
